// extracted by mini-css-extract-plugin
export var category = "index-module--category--mCIQc";
export var comparisonContainer = "index-module--comparisonContainer--25iWj";
export var container = "index-module--container--JDlf4";
export var gradBorder = "index-module--gradBorder--S1mxx";
export var row = "index-module--row--3lVB-";
export var subtitle = "index-module--subtitle--PMh80";
export var title = "index-module--title--2fAYd";
export var titleContainer = "index-module--titleContainer--KrQkS";
export var value = "index-module--value--ROJ3r";